// extracted by mini-css-extract-plugin
var _1 = "VersionChangesWallAuthorCard-module__animateUploadProgressBarWidth--XBdwu";
var _2 = "VersionChangesWallAuthorCard-module__animatedBackground--sK_qz";
var _3 = "VersionChangesWallAuthorCard-module__asPopOver--Apwac";
var _4 = "VersionChangesWallAuthorCard-module__authorName--fqCTH";
var _5 = "VersionChangesWallAuthorCard-module__avatar--Tqd18";
var _6 = "VersionChangesWallAuthorCard-module__button--drjhV";
var _7 = "VersionChangesWallAuthorCard-module__card--Dsxdh";
var _8 = "VersionChangesWallAuthorCard-module__content--B9ovj";
var _9 = "VersionChangesWallAuthorCard-module__date--pmFhC";
var _a = "VersionChangesWallAuthorCard-module__isFocused--QnOaM";
var _b = "VersionChangesWallAuthorCard-module__isMenuOpen--QSGqq";
var _c = "VersionChangesWallAuthorCard-module__menu--QJWXH";
var _d = "274px";
var _e = "VersionChangesWallAuthorCard-module__popOver--EBBVZ";
var _f = "VersionChangesWallAuthorCard-module__wrapper--GVaiC";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "asPopOver", _4 as "authorName", _5 as "avatar", _6 as "button", _7 as "card", _8 as "content", _9 as "date", _a as "isFocused", _b as "isMenuOpen", _c as "menu", _d as "normalWidth", _e as "popOver", _f as "wrapper" }
